export const RATIO_SQUARE = [1, 1];
export const RATIO_PORTRAIT = [9, 16];
export const RATIO_LANDSCAPE = [16, 9];
